$(function () {
    $('body').on('click', '.b-selection-dates__link', (e) => {
        const $link = $(e.currentTarget);
        const $block = $link.closest('.b-selection-dates');
        const $links = $link.siblings().add($link);
        const $sections = $block.find('.b-selection-dates__section');
        const index = $link.index();

        $links.removeClass('is-active').eq(index).addClass('is-active');
        $sections.removeClass('is-active').eq(index).addClass('is-active');
    });

    $('.b-selection-dates__search').on('submit', function (event) {
        event.preventDefault();
        var $form = $(this);
        var isActive = $form.data('active');
        if(isActive) {
            return
        }

        $form.data('active', true);

        if(window.innerWidth <= 1024) {
            return;
        }

        var $prevForm = $form.prev();
        var formWidth =  $form.width();
        var prevFormWidth =  $prevForm.width();
        $prevForm.css({'display': 'none'});
        $form.width(formWidth + prevFormWidth);

        var $input = $form.find('.b-selection-dates__search-input');
        $input.addClass('b-selection-dates__search-input_active').focus();

        var $label = $form.find('.b-selection-dates__search-label');
        // задержка для анимации перехода input { transition: width 0.2s ease-out; }
        setTimeout(function () {
            $label.addClass('b-selection-dates__search-label_active');
        }, 200);

        $(document).on('click', disabledForm);

        function disabledForm(event) {
            var target = event.target;
            if(!target.closest('.b-selection-dates__search')) {
                $label.removeClass('b-selection-dates__search-label_active');
                $input.removeClass('b-selection-dates__search-input_active');
                // задержка для анимации перехода input { transition: width 0.2s ease-out; }
                setTimeout(function () {
                    $prevForm.css({'display': ''});
                    $form.css({'width': ''});
                    $form.data('active', false);
                }, 200);
                $(document).off('click', disabledForm);
            }
        }
    })
});
